// Service worker registration for Blisson PWA
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register on production-like origins to avoid cache issues during local dev
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Listen for new SW waiting
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New version available — activate immediately
              installing.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        // ignore registration errors
      });
  });
}
